import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
  computed,
} from '@angular/core';
import type {
  FaceItemModel,
  Facet,
  FilterSelection,
} from '@fantaz/shared/data-access/models';
import { ChipGroup, FzChip } from '@fantaz/shared/ui/chip';

@Component({
  selector: 'fz-current-refinements',
  standalone: true,
  imports: [ChipGroup, FzChip],
  templateUrl: './current-refinements.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-current-refinements',
  },
})
export class CurrentRefinementList {
  facet = input.required<Facet>();
  filters = input<FilterSelection>({});
  removeItem = output<{ group: string; key: string }>();

  items = computed(() => {
    const currentSelection = Object.keys(this.filters()).reduce(
      (acc, key) => {
        const group = this.facet()[key] || {};
        const items = group.items || [];
        const selected = this.filters()[key] || [];

        return [
          ...acc,
          ...items
            .filter((item) => selected.includes(item.key))
            .map((item) => ({
              ...item,
              group: key,
            })),
        ];
      },
      [] as (FaceItemModel & { group: string })[],
    );

    // include search
    const search = this.filters()['q']
      ? this.filters()
          ['q'].filter((v) => v.trim() !== '')
          .map(
            (q) =>
              ({
                key: q,
                image: '',
                tooltip: '',
                label: `"${q}"`,
                group: 'q',
              }) as unknown as FaceItemModel & { group: string },
          )
      : [];

    return [...currentSelection, ...search];
  });

  /**
   * Removes a filter item from the selection.
   *
   * @param {string} key - The key of the filter item to remove.
   */
  removeSelection(group: string, key: string) {
    this.removeItem.emit({ group, key });
  }
}
